"use client";
import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaCaretLeft, FaCaretRight } from "react-icons/fa";
import { IoMdHeart, IoMdHeartEmpty } from "react-icons/io";
import NewFavoriteFolderModal from "../../../components/myFav/NewFavoriteFolderModal";
import img1 from "../../../assets2/images/archdentity.jpg";
import img2 from "../../../assets2/images/playhouse.jpg";
import img3 from "../../../assets2/images/laperli.jpg";
import img4 from "../../../assets2/images/arena.jpg";
import VenueCard from "../../../components/shared/card/venue/VenueCard";
import { useQuery } from "@tanstack/react-query";
import { getUser } from "../../../lib/apis";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { base_URL } from "../../../config/config";
import AddedFavoriteModal from "../../../components/myFav/AddedFavoriteModal";

const provideData = [
  {
    images: [{ img1: img1 }, { img1: img1 }, { img1: img1 }],
    name: "Archidentity, The Palm",
    loc: "Dubai, Downtown",
    sitting: "200",
    standing: "200",
    feature: "Photoshoot . Indoor & Outdoor",
    perGuest: "105",
    minSpend: "2000",
  },
  {
    images: [{ img1: img2 }, { img1: img2 }, { img1: img2 }],
    name: "Playhouse, Grand Hyatt",
    loc: "Dubai, Downtown",
    sitting: "200",
    standing: "200",
    feature: "Photoshoot . Indoor & Outdoor",
    perGuest: "105",
    minSpend: "2000",
  },
  {
    images: [{ img1: img3 }, { img1: img3 }, { img1: img3 }],
    name: "La Perle, The Luxe",
    loc: "Dubai, Downtown",
    sitting: "200",
    standing: "200",
    feature: "Photoshoot . Indoor & Outdoor",
    perGuest: "105",
    minSpend: "2000",
  },
  {
    images: [{ img1: img4 }, { img1: img4 }, { img1: img4 }],
    name: "Arena Hall, The Royals",
    loc: "Dubai, Downtown",
    sitting: "200",
    standing: "200",
    feature: "Photoshoot . Indoor & Outdoor",
    perGuest: "105",
    minSpend: "2000",
  },
];

const DetailComponent = ({ data }) => {
  console.log("searchData", Array.isArray(data), typeof data, data);
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const [isMobileView, setIsMobileView] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalAddedOpen, setIsModalAddedOpen] = useState(false);
  const [newFolder, setNewFolder] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [favItem, setFavItem] = useState(null);
  const sliderRef = useRef(null);

  const getFavoriteFolder = async () => {
    try {
      const response = await fetch(
        `${base_URL}/api/auth/get-folders/${user?._id}`
      );
      if (!response.ok) {
        console.log("Failed to fetch Venues");
        return;
      }
      const data = await response.json();
      refetchFav1();
      return data.folders;
    } catch (err) {
      console.log(err);
    }
  };

  const getUserInfo = async () => {
    const userInfo = await getUser(user?._id);
    let venuesAndStay = [];
    userInfo.favoritesFolder.forEach((folder) => {
      if (folder.venues.length > 0) {
        venuesAndStay = [...venuesAndStay, ...folder.venues];
      }
    });
    return venuesAndStay;
  };

  const { folders, refetch } = useQuery({
    queryKey: ["favoriteFolder", user?._id],
    queryFn: getFavoriteFolder,
    enabled: !!user?._id,
  });

  const { data: userFavorites, refetch: refetchFav1 } = useQuery({
    queryKey: ["userFavorites12"],
    queryFn: getUserInfo,
    enabled: !!user?._id,
  });

  const handleViewPrev = (item) => {
    const cf = "hpv"; // Home Page Venue
    const venueId = item?.id;
    const slug = item?.name
      ?.toLowerCase()
      ?.replace(/[^a-z0-9]+/g, "-") // replace spaces/specials with hyphens
      ?.replace(/(^-|-$)/g, ""); // trim leading/trailing hyphens
    navigate(`/preview/${cf}/${venueId}/${slug}`, {
      state: {
        breadcrumbPath: [
          { name: "Home", to: "/" },
          { name: item?.name, to: "" },
        ],
      },
    });
  };

  const handleClickFavorite = async (e, itemId) => {
    e.stopPropagation();
    if (!itemId) return;

    if (!user) {
      return toast.error("Please login first");
    }

    const isFavorited =
      userFavorites && userFavorites.find((favorite) => favorite.id === itemId);

    if (isFavorited) {
      // If already favorited, remove it
      await removeFavorite(itemId);
      refetch();
    } else {
      refetch();
      // If not favorited, add it
      setFavItem(itemId);
      user?.favoritesFolder?.length > 0
        ? setIsModalAddedOpen(true)
        : setIsModalOpen(true);
    }
  };

  const removeFavorite = async (itemId) => {
    try {
      const response = await axios.post(
        `${base_URL}/api/favorite/remove-favorite`,
        {
          userId: user._id,
          itemId,
        }
      );

      if (response?.data?.success) {
        toast.success("Removed from favorites");
        refetchFav1();
      } else {
        toast.error("Failed to remove from favorites");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while removing from favorites");
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 1280);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const mainCarouselSettings = {
    dots: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    afterChange: (index) => setCurrentSlide(index),
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const favoriteOverlayComp = (item) => {
    return (
      <div
        className="bg-white absolute top-3 right-5 p-1.5 rounded-full shadow cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          handleClickFavorite(e, item?.id, 0);
        }}
      >
        {userFavorites?.find((favorite) => favorite.id === item.id) ? (
          <IoMdHeart className="text-primary" />
        ) : (
          <IoMdHeartEmpty className="text-primary" />
        )}
      </div>
    );
  };

  return (
    <>
      {newFolder && (
        <NewFavoriteFolderModal
          isOpen={newFolder}
          refetch={refetch}
          onClose={() => {
            setNewFolder(false);
            refetchFav1();
          }}
          itemId={favItem}
          type={"venue"}
        />
      )}
      {user?.favoritesFolder?.length > 0 ? (
        <AddedFavoriteModal
          setNewFolder={setNewFolder}
          isOpen={isModalAddedOpen}
          refetch={refetch}
          itemId={favItem}
          data={folders}
          type={"venue"}
          onClose={() => {
            setIsModalAddedOpen(false);
            refetchFav1();
          }}
        />
      ) : (
        <NewFavoriteFolderModal
          isOpen={isModalOpen}
          itemId={favItem}
          refetch={refetch}
          type={"venue"}
          onClose={() => {
            setIsModalOpen(false);
            refetchFav1();
          }}
        />
      )}

      {/* {isShowModal && <NewFavoriteFolderModal />} */}
      <div className="w-full">
        {isMobileView ? (
          <div className="relative px-4">
            {currentSlide > 0 && (
              <button
                onClick={() => sliderRef.current?.slickPrev()}
                className="absolute left-[-5px] top-1/2 -translate-y-1/2 z-10"
              >
                <FaCaretLeft className="size-5" />
              </button>
            )}
            {currentSlide < data.length - 1 && (
              <button
                onClick={() => sliderRef.current?.slickNext()}
                className="absolute right-[-5px] top-1/2 -translate-y-1/2 z-10"
              >
                <FaCaretRight className="size-5" />
              </button>
            )}
            <Slider {...mainCarouselSettings} ref={sliderRef}>
              {data.map((item, itemIndex) => (
                <div key={itemIndex} className="px-2 py-12">
                  <VenueCard
                    onClick={(e) => {
                      e.preventDefault();
                      handleViewPrev(item);
                    }}
                  >
                    <VenueCard.Slider images={item.images}>
                      {favoriteOverlayComp(item)}
                    </VenueCard.Slider>
                    <VenueCard.Details>
                      <VenueCard.VenueName>{item.name}</VenueCard.VenueName>
                      <VenueCard.Location>{item.loc}</VenueCard.Location>
                      <VenueCard.Icons
                        sittingCapacity={item.sitted}
                        standingCapacity={item.stand}
                      />
                      <VenueCard.Activity
                        venueRepresent={item.activity}
                        venueSetting={
                          item.setting === "Indoor + Outdoor"
                            ? "Indoor & Outdoor"
                            : item.setting
                        }
                      />
                      <div className="flex items-start w-full justify-between">
                        <VenueCard.Pricing
                          showGuests={item.minSpendPerPerson}
                          minSpendPerPerson={item.minSpendPerPerson}
                          minSpendPricing={
                            item.minSpendPricing || item.venueRental
                          }
                        />
                      </div>
                    </VenueCard.Details>
                  </VenueCard>
                </div>
              ))}
            </Slider>
          </div>
        ) : (
          <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-6 gap-y-12 max-h-[480px]">
            {data.map((item, itemIndex) => (
              <VenueCard
                key={itemIndex}
                onClick={(e) => {
                  e.preventDefault();
                  handleViewPrev(item);
                }}
              >
                <VenueCard.Slider images={item.images}>
                  {favoriteOverlayComp(item)}
                </VenueCard.Slider>
                <VenueCard.Details>
                  <VenueCard.VenueName>{item.name}</VenueCard.VenueName>
                  <VenueCard.Location>{item.loc}</VenueCard.Location>
                  <VenueCard.Icons
                    sittingCapacity={item.sitted}
                    standingCapacity={item.stand}
                  />
                  <VenueCard.Activity
                    venueRepresent={item.activity}
                    venueSetting={
                      item.setting === "Indoor + Outdoor"
                        ? "Indoor & Outdoor"
                        : item.setting
                    }
                  />
                  <div className="flex items-start w-full justify-between">
                    <VenueCard.Pricing
                      showGuests={item.minSpendPerPerson}
                      minSpendPerPerson={item.minSpendPerPerson}
                      minSpendPricing={item.minSpendPricing || item.venueRental}
                    />
                  </div>
                </VenueCard.Details>
              </VenueCard>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default DetailComponent;
